<template>
    <router-view></router-view>
</template>

<script>
import CommonMixin from "@/mixins/commonMixin";

export default {
    name  : "Map",
    mixins: [CommonMixin],
  }
</script>

<style lang="scss">
    ul.ctx-menu > li{
        padding: 3px 10px;
        white-space: nowrap;
    }
</style>
